import { Expose, plainToInstance, Type } from 'class-transformer';
import { OwnerFillInStatusDto } from './owner-fill-in-status.dto';
import { OwnerDto } from './owner.dto';

export class OwnerSimplifiedDto {
  @Expose()
  id: string;

  @Expose()
  proprietarioCadastroId: string;

  @Expose()
  name: string;

  @Expose()
  main?: boolean;

  @Expose()
  @Type(() => OwnerFillInStatusDto)
  fillInStatus: OwnerFillInStatusDto;

  /**
   * Cria uma nova instância de OwnerSimplifiedDto a partir de dtos
   * @param props DTO de Owner
   * @returns nova instância de OwnerSimplifiedDto
   */
  static from(props?: OwnerDto | Partial<OwnerDto>): OwnerSimplifiedDto {
    return plainToInstance(OwnerSimplifiedDto, props, { exposeUnsetFields: false, excludeExtraneousValues: true });
  }
}
